import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/default.png';
interface Props extends RankItem {
  width: number,
  special?: boolean,
  rich?: boolean,
  up?: boolean,
  down?: boolean,
}
const Images = Object.keys({
  rankno1: 'rankno1',
  rankno2: 'rankno2',
  rankno3: 'rankno3',
  ranknon: 'ranknon',
  living: 'living',
}).map((item: any) => require(`@images/${item}.png`));
const AnchorItem: React.FC<Props> = props => (
  <div
    style={
      {
        width: props.width + 'px',
        height: props.special ? '52px' : props.rich ? '82px' : '62px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundSize: '332px 82px',
        paddingTop: '0px',
      }
    }
  >
    {
      props.special && <p style={{color: 'rgb(214, 179, 122)', fontSize: '12px'}}>{'NO.' + props.iRank}</p>
    }
    {
      !props.special &&
      <i
        style={
          (props.iRank <= 3 ) ? {
            width: '19px',
            height: '22px',
            marginLeft: '5px',
            background: `url(${Images[props.iRank - 1].default}) center center no-repeat`,
            backgroundSize: '100% 100%',
          } : {
            width: '19px',
            height: '22px',
            background: `url(${Images[3].default}) center center no-repeat`,
            backgroundSize: '100% 100%',
            color: 'rgb(214, 179, 122)',
            textAlign: 'center',
            lineHeight: '25px',
            marginLeft: '5px',
            fontSize: '10px',
          }
        }
      >
        {
          (props.iRank <= 3) ? '' : props.iRank
        }
      </i>
    }
    <div
      style={
        {
          width: '170px',
          display: 'flex',
          alignItems: 'center',
          marginLeft: '35px',
        }
      }
    >
      <div
        style={
          {
            position: 'relative',
            width: props.rich ? '62px' : '42px',
            height: props.rich ? '62px' : '42px',
            borderRadius: '50%',
            marginRight: '8px',
          }
        }
      >
        <img
          style={
            {
              width: props.rich ? '60px' : '40px',
              height: props.rich ? '60px' : '40px',
              borderRadius: '50%',
              border: '1px solid rgb(214, 179, 122)',
              cursor: props.rich ? 'default' : 'pointer',
            }
          }
          title={props.sNickName}
          src={props.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          onClick={(): void => {
            if (props.rich) return;
            window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
          }}
        />
        {
          props.tJump.bIsLive && !props.rich &&
            <i
              style={
                {
                  position: 'absolute',
                  right: '0px',
                  bottom: '0px',
                  width: '13px',
                  height: '13px',
                  background: `url(${Images[4].default}) center center no-repeat`,
                  backgroundSize: '100% 100%',
                }
              }
            ></i>
        }
      </div>
      <p
        style={
          {
            width: (props.up || props.down) ? '74px' : '120px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: '0px',
            fontSize: '14px',
            color: 'rgb(214, 179, 122)',
            textAlign: 'left',
            cursor: props.rich ? 'default' : 'pointer',
          }
        }
        onClick={(): void => {
          if (props.rich) return;
          window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
        }}
      >
        {props.sNickName}
      </p>
      {props.up && <i className='rank-up' />}
      {props.down && <i className='rank-down' />}
    </div>
    <p
      style={
        {
          width: '80px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          margin: '0px',
          fontSize: '14px',
          color: 'rgb(214, 179, 122)',
          textAlign: 'right',
        }
      }
    >{props.lScore}</p>
  </div>
)
export default AnchorItem;